import { JWT_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../../constants/auth";

export const getSessionStorage = (key: string) => {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null;
}

export const setSessionStorage = (key: string, value: any) => {
    sessionStorage.setItem(key, JSON.stringify(value));
}

export const removeSessionStorage = (key: string) => {
    sessionStorage.removeItem(key);
}

export const clearSessionStorage = () => {
    sessionStorage.clear();
}

export const clearTokenSessionStorage = () => {
    removeSessionStorage(JWT_TOKEN_KEY);
    removeSessionStorage(REFRESH_TOKEN_KEY);
}

export const getTokenSessionStorage = () => {
    return {
        accessToken: getSessionStorage(JWT_TOKEN_KEY),
        rfToken: getSessionStorage(REFRESH_TOKEN_KEY),
    }
}